import { useState } from 'react'
import { Pin } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { financeService } from '@/services/financeService'
import { toast } from 'sonner'

type Props = {
  dealId: string
  disabled?: boolean
}

export function FixPropostaButton({ dealId, disabled }: Props) {
  const [loading, setLoading] = useState(false)

  const handleFix = async () => {
    setLoading(true)
    try {
      await financeService.fixPropostaForDeal(dealId)
      toast.success('Proposta fixada para o financeiro')
    } catch {
      toast.error('Não foi possível fixar a proposta (verifique empresa e proposta enviada)')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      type='button'
      variant='secondary'
      size='sm'
      disabled={disabled || loading}
      onClick={handleFix}
      className='gap-1.5'
    >
      <Pin size={14} />
      {loading ? 'Fixando…' : 'Fixar proposta para financeiro'}
    </Button>
  )
}
